import { Component,OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {ReportserviceService}  from '../../reportservice.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import {SurgeonSummeryData} from '../data'
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-surgeon-wise-month',
  templateUrl: './surgeon-wise-month.component.html',
  styleUrls: ['./surgeon-wise-month.component.scss']
})
export class SurgeonWiseMonthComponent implements OnInit {

  public link: string = 'https://medium.com/@garfunkel61/angular-simplest-solution-for-social-sharing-feature-6f00d5d99c5e';  
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  pageHeading:any;
  public toDaysDate:any;
  public SurgeonSummaryArray:any =[];
  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;
  isnewcolor =false;
  public setcharttype;
  public senddataArray:any = [];
  public serchdata:any =[];
  public Labels =['Surgeon Name','Total','Contribution','Male','Female'];
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartData: ChartDataSets[] = [
    { data: [10,8,9,11,9], label: 'Surgeon Wise Summary' }
  ];
  public pieChartLabels: Label[] = this.Labels;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  
  
  
  constructor(public reportservice:ReportserviceService,public dbservice:DashboardService, 
    public opdvisitService: OpdVisitService, public authService :AuthService,
    private datePipe: DatePipe,private exportdata:ExportService) {
        monkeyPatchChartJsTooltip();
        monkeyPatchChartJsLegend();
        this.pageHeading =  'Surgeon Month Wise'
        }
  
    ngOnInit(): void {
      this.SurgeonSummaryArray =SurgeonSummeryData;
      this.toDaysDate = this.authService.getServerDate;
      this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
      console.log(this.toDaysDate);

      this.reportservice.get_opd_doctor_sdate_edate(this.toDaysDate,this.toDaysDate).
      subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
   
      }
  
  setgraptype(type){
   this.pieChartType =type;
  }
  
  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }
  
  togglegraphIf() {
    this.isGraph = !this.isGraph;
  }
  
  togglegraphDataIf() {
    this.isgrapandData = !this.isgrapandData;
  }
  
  // togglemonthelyIf(data) {
  //   if(data === 'yes'){
  //     this.ismonthly = !this.ismonthly;
  //     this.OpdDoctorArray =  SurgeonSummeryData;
  //     this.Labels =['OPT Doctor','Total','Fresh','Review','Male','Female','Cross Reff',
  //   'Dillated','Walk In','With Appt','TAT'];
  //   this.pieChartData =[
  //     { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD Doctor Analysis' },
  //      { data: [8,10,8,7,9,6,5,8,9,11,9], label: 'OPD DateWise Analysis', }
  //   ];
  //   this.pageHeading = 'OPD Doctor Wise Reports'
   
  //   }
  //   else{
  //     this.ismonthly = !this.ismonthly;
  //     this.OpdDoctorArray =  SurgeonSummeryData;
  //     this.Labels =['OPT Doctor','Total','Fresh','Review','Male','Female','Cross Reff',
  //     'Dillated','Walk In','With Appt','TAT'];
  //     this.pieChartData =[
  //       { data: [8,10,8,7,9,6,5,8,9,11,9], label: 'OPD Doctor Analysis' }
  //     ];
  //     this.pageHeading = 'OPD Doctor Wise Reports'
      
  //   }
  
    
  // }
   
 
  
  
  
  get_records_between_two_dates(){
   
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  
   this.reportservice.get_opd_doctor_sdate_edate(sdate,edate).
   subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  }
  
  success_pat_sdate_edate(data){
    // this.OpdDoctorArray =data;
    console.log(data)

  }
  failed_pat_sdate_edate(err){
  this.showspinner = false;
  }
  
  

  exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }
  
  
  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.download(DATA);
        
  }
  
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
  }
  public printPDF(): void {
    this.exportdata.printpDFData(); 
}
 
  
  
  
  }
  